export const GROUP_FILTER_ALL = "__all__";
export const GROUP_UNGROUPED = "";

export type GroupedItems<T> = { groupName: string; items: T[] };

export function groupByGroupName<T extends { GroupName: string }>(items: T[]): GroupedItems<T>[] {
  const map = new Map<string, T[]>();

  for (const item of items) {
    const key = item.GroupName || GROUP_UNGROUPED;
    const arr = map.get(key);
    if (arr) arr.push(item);
    else map.set(key, [item]);
  }

  return Array.from(map.entries())
    .sort(([a], [b]) => {
      if (a === GROUP_UNGROUPED) return 1;
      if (b === GROUP_UNGROUPED) return -1;
      return a.localeCompare(b, "fr");
    })
    .map(([groupName, items]) => ({ groupName, items }));
}

export function extractGroupOptions<T extends { GroupName: string }>(items: T[]): string[] {
  const set = new Set<string>();
  items.forEach((item) => {
    if (item.GroupName) set.add(item.GroupName);
  });
  return Array.from(set).sort((a, b) => a.localeCompare(b, "fr"));
}

export function filterByGroup<T extends { GroupName: string }>(
  items: T[],
  selectedGroup: string,
): T[] {
  if (selectedGroup === GROUP_FILTER_ALL) return items;
  if (selectedGroup === GROUP_UNGROUPED) return items.filter((item) => !item.GroupName);
  return items.filter((item) => item.GroupName === selectedGroup);
}
